import type { IEvent } from '@/interfaces';

export enum LifeCycleState {
    pre,
    live,
    post,
    available,
}

export const calculateLifeCycleState = (event: IEvent, liveThresholdInMins = 14) => {
    // Event becomes live 15 minutes before the start of the event
    // and we allow the link 1 min later in case of upstream delays
    if (new Date(Date.now() + liveThresholdInMins * 60 * 1000) < new Date(event.startDate)) {
        return LifeCycleState.pre;
    } else if (new Date(Date.now()) < new Date(event.endDate)) {
        return LifeCycleState.live;
    }
    return LifeCycleState.post;
};
